import { Collapse as BaseCollapse } from "antd"
import { ComponentProps } from "react"

export function Collapse(props: ComponentProps<typeof BaseCollapse>) {
    return <BaseCollapse {...props} />
}
